/**
 * 交換品発送ページ用のスクリプト
 */
if (is_route('bss_replacement_shipping.index')) {
    // スクリプト読込
    require('../Base/replacement_shipping_base.index');
    
    // コンテンツ読み込み後
    $(document).on('bss:onload', function() {
        replacement_shipping_base_event_set();
        replacement_shipping_base_setting_event_set();
    });
}